/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 133 24"
    data-name="SvgRectangle05"
    {...props}
  >
    {props.children}
    <path
      fill="#C9DDE9"
      d="M2 .458h118.892L132.354 12l-11.462 11.542H2c-.851 0-1.542-.69-1.542-1.542V2c0-.851.69-1.542 1.542-1.542"
    />
    <path
      fill="url(#rectangle05_svg__a)"
      fillOpacity={0.4}
      d="M2 .458h118.892L132.354 12l-11.462 11.542H2c-.851 0-1.542-.69-1.542-1.542V2c0-.851.69-1.542 1.542-1.542"
    />
    <path
      stroke="url(#rectangle05_svg__b)"
      strokeWidth={0.917}
      d="M2 .458h118.892L132.354 12l-11.462 11.542H2c-.851 0-1.542-.69-1.542-1.542V2c0-.851.69-1.542 1.542-1.542Z"
    />
    <defs>
      <linearGradient
        id="rectangle05_svg__a"
        x1={42.981}
        x2={48.047}
        y1={-2.907}
        y2={24.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rectangle05_svg__b"
        x1={11.222}
        x2={14.26}
        y1={0.45}
        y2={28.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={0.406} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={0.574} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.4} />
      </linearGradient>
    </defs>
  </svg>
)
